import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Restores scroll position and moves focus to the top of the document on
 * route change. Without the focus move, screen-reader and keyboard users stay
 * parked wherever they clicked, which makes a SPA feel like nothing happened.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

    const main = document.getElementById('main');
    if (main) {
      main.setAttribute('tabindex', '-1');
      main.focus({ preventScroll: true });
      // Drop the tabindex again so main doesn't linger in the tab order.
      main.addEventListener('blur', () => main.removeAttribute('tabindex'), { once: true });
    }
  }, [pathname]);

  return null;
}
